import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { createStore, withProps, select } from '@ngneat/elf';

import {
  UserSettings,
  UserSettingsObject,
} from '@digital-platform/users/domain';
import { LoginSessionFacadeService } from '../login-session-facade.service';

// Normally all of this would have followed the facade pattern, but I wanted to keep this isolated
// since it has nothing to do with the AURA stuff.

interface UserSettingsState {
  settings: UserSettings | null;
}

const store = createStore(
  { name: 'UserSettings' },
  withProps<UserSettingsState>({
    settings: null,
  })
);

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  public readonly settings$ = store.pipe(select((state) => state.settings));

  private readonly httpClient = inject(HttpClient);
  private readonly loginSessionFacadeService = inject(
    LoginSessionFacadeService
  );

  constructor() {
    this.loginSessionFacadeService.loginSession$.subscribe((session) => {
      if (session) {
        this.loadUserSettings();
      } else {
        store.update((state) => ({
          ...state,
          settings: null,
        }));
      }
    });
  }

  public loadUserSettings() {
    const url = `api/users/settings`;
    this.httpClient.get<UserSettingsObject>(url).subscribe((response) => {
      store.update((state) => ({
        ...state,
        settings: response,
      }));
    });
  }

  public updateUserSettings(settings: Partial<UserSettingsObject>) {
    const url = `api/users/settings`;

    const currentVal = store.getValue();
    const updates = new UserSettings({ ...currentVal.settings, ...settings });

    this.httpClient
      .put<UserSettingsObject>(url, updates)
      .subscribe((response) => {
        store.update((state) => ({
          ...state,
          settings: response,
        }));
      });
  }
}
